import PropTypes from "prop-types";
import { useRef, useState } from "react";

import styled from "styled-components/macro";

import FnrButton from "UI/FnrButton3";
import FnrConfirmationPopover from "UI/FnrConfirmationPopover";

import FnrFetch3 from "../../Utilities/FnrFetch/FnrFetch3";

ActivateFNPButton.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
  fullWidth: PropTypes.bool,
  children: PropTypes.node,
  price: PropTypes.number,
};

export default function ActivateFNPButton({
  color = "blue",
  size = "large",
  fullWidth = false,
  children,
  price = 75,
}) {
  const triggerRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);

  function activateFlocknotePeople() {
    setShowConfirmation(false);
    setIsLoading(true);
    const signupForPaymentsCall = new FnrFetch3(`/people/startSubscription`);
    signupForPaymentsCall
      .post()
      .then((resp) => {
        var alertInfo = {
          title: "Success!",
          message:
            "You've upgraded to the <em>Flocknote Complete</em> package and unlocked a robust, integrated database that supercharges your member management and engagement!",
          subtext: `This upgrade is an additional $${
            resp.price ?? price
          } / month and can monitored in the billing section. Questions? Email help@flocknote.com.`,
          type: "default",
          buttonAddClass: "green",
          buttonText: "Let's do this!",
          contextObj: {
            refreshFlocknote: () => window.location.reload(),
          },
          onConfirm: "refreshFlocknote",
          hideBackground: true,
        };
        window.fnReactBus.openLegacyAlert(alertInfo);
      })
      .catch((err) => {
        var alertInfo = {};
        if (err.error === "payment_method") {
          alertInfo = {
            title: "Missing Payment Method",
            message:
              "Whoops! It looks like we do not have a payment method on file for this network. You will need to add one before adding <em>Flocknote Complete</em>.",
            type: "default",
            buttonAddClass: "green",
            buttonText: "Add Payment Method",
            denyButton: "Cancel",
            contextObj: {
              handleMissingPaymentAlertConfirm: (alertObj) => {
                window.fnReactBus.goToUrl(
                  "billing/collectOneTimePaymentInfo?conv=1"
                );
                alertObj.closeAlert();
              },
              handleMissingPaymentAlertClose: () => {},
            },
            onConfirm: "handleMissingPaymentAlertConfirm",
            onClose: "handleMissingPaymentAlertClose",
            hideBackground: true,
          };
        } else {
          alertInfo = {
            title: "Something went wrong!",
            message:
              "Uh oh! Something went wrong trying to activate Flocknote Complete. Please try again later or contact help@flocknote.com.",
            type: "default",
            buttonAddClass: "green",
            buttonText: "Ok",
            hideBackground: true,
            contextObj: {
              handleConfirm: (alertObj) => {
                alertObj.closeAlert();
              },
            },
            onConfirm: "handleConfirm",
          };
        }
        window.fnReactBus.openLegacyAlert(alertInfo);
        setIsLoading(false);
      });
  }

  return (
    <>
      <span ref={triggerRef}>
        <FnrButton
          type="button"
          color={color}
          size={size}
          loading={isLoading}
          onClick={() => setShowConfirmation(!showConfirmation)}
          fullWidth={fullWidth}
        >
          {children ? (
            children
          ) : (
            <>
              <Icon className="fas fa-plus" />
              Upgrade&nbsp;Now
            </>
          )}
        </FnrButton>
      </span>

      <FnrConfirmationPopover
        show={showConfirmation}
        ref={triggerRef}
        onClose={() => setShowConfirmation(false)}
        message={
          <div>
            Upgrade to <em>Flocknote Complete</em> for an additional ${price}
            /month. No contracts. Cancel anytime.
          </div>
        }
        button1={
          <FnrButton text="Cancel" onClick={() => setShowConfirmation(false)} />
        }
        button2={
          <FnrButton
            text="Sign us up!"
            onClick={activateFlocknotePeople}
            color="blue"
          />
        }
        style={{ maxWidth: 270, padding: 16 }}
      />
    </>
  );
}

const Icon = styled.span`
  margin-right: 0.6rem;
`;
